export enum NoPaymentReasonLulo {
  ILIQUIDEZ_TRANSITORIA = 'ILIQUIDEZ TRANSITORIA (<1 MES)',
  AUMENTO_DE_GASTOS = 'AUMENTO DE GASTOS',
  REDUCCION_INGRESOS = 'REDUCCIÓN INGRESOS',
  LEY_DE_INSOLVENCIA = 'LEY DE INSOLVENCIA',
  CALAMIDAD = 'CALAMIDAD',
  INCAPACIDAD = 'INCAPACIDAD',
  DESEMPLEO = 'DESEMPLEO',
  OLVIDO_PAGO = 'OLVIDÓ PAGO',
  CAMBIO_FECHA_PAGO = 'CAMBIO FECHA PAGO',
  NO_RECONOCE_EL_CREDITO = 'NO RECONOCE EL CRÉDITO',
  RECLAMACION = 'RECLAMACIÓN',
  NO_IDENTIFICA_MORA = 'NO IDENTIFICA MORA',
  DIFICULTADES_PAGO_APP = 'DIFICULTADES PAGO APP',
  FALLAS_EN_LA_APP = 'FALLAS EN LA APP',
  NO_RECIBIO_EXTRACTO = 'NO RECIBIO EXTRACTO',
  DEBITO_NO_OPERO = 'DEBITO NO OPERÓ',
  NO_CONTACTO = 'NO CONTACTO',
}

export const noPaymentReasonLulo = () => [
  {
    label: 'Iliquidez transitoria (<1 mes)',
    value: NoPaymentReasonLulo.ILIQUIDEZ_TRANSITORIA,
  },
  {
    label: 'Aumento de gastos',
    value: NoPaymentReasonLulo.AUMENTO_DE_GASTOS,
  },
  {
    label: 'Reducción ingresos',
    value: NoPaymentReasonLulo.REDUCCION_INGRESOS,
  },
  {
    label: 'Ley de insolvencia',
    value: NoPaymentReasonLulo.LEY_DE_INSOLVENCIA,
  },
  {
    label: 'Calamidad',
    value: NoPaymentReasonLulo.CALAMIDAD,
  },
  {
    label: 'Incapacidad',
    value: NoPaymentReasonLulo.INCAPACIDAD,
  },
  {
    label: 'Desempleo',
    value: NoPaymentReasonLulo.DESEMPLEO,
  },
  {
    label: 'Olvidó pago',
    value: NoPaymentReasonLulo.OLVIDO_PAGO,
  },
  {
    label: 'Cambio fecha pago',
    value: NoPaymentReasonLulo.CAMBIO_FECHA_PAGO,
  },
  {
    label: 'No reconoce el crédito',
    value: NoPaymentReasonLulo.NO_RECONOCE_EL_CREDITO,
  },
  {
    label: 'Reclamación',
    value: NoPaymentReasonLulo.RECLAMACION,
  },
  {
    label: 'No identifica mora',
    value: NoPaymentReasonLulo.NO_IDENTIFICA_MORA,
  },
  {
    label: 'Dificultades pago app',
    value: NoPaymentReasonLulo.DIFICULTADES_PAGO_APP,
  },
  {
    label: 'Fallas en la app',
    value: NoPaymentReasonLulo.FALLAS_EN_LA_APP,
  },
  {
    label: 'No recibio extracto',
    value: NoPaymentReasonLulo.NO_RECIBIO_EXTRACTO,
  },
  {
    label: 'Debito no operó',
    value: NoPaymentReasonLulo.DEBITO_NO_OPERO,
  },
  {
    label: 'No contacto',
    value: NoPaymentReasonLulo.NO_CONTACTO,
  },
];
